var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrademateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_206_5328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 12,
    fill: "#1877F2",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 26.8571L20.4603 23.88C21.1979 22.3763 23.3658 22.4498 23.9999 23.9999C24.6341 25.5501 26.802 25.6235 27.5396 24.1198L28.9999 21.1428M23.9999 33.5262C21.4527 33.5262 20.179 33.5262 19.1045 32.975C18.9573 32.8995 18.814 32.8167 18.675 32.727C17.6604 32.0721 17.0236 30.9691 15.7499 28.7631C14.4763 26.557 13.8395 25.454 13.7796 24.2479C13.7714 24.0827 13.7714 23.9172 13.7796 23.752C13.8395 22.5458 14.4763 21.4428 15.7499 19.2368C17.0236 17.0308 17.6604 15.9278 18.675 15.2728C18.814 15.1831 18.9573 15.1004 19.1045 15.0249C20.179 14.4736 21.4527 14.4736 23.9999 14.4736C26.5472 14.4736 27.8209 14.4736 28.8954 15.0249C29.0425 15.1004 29.1859 15.1831 29.3248 15.2728C30.3395 15.9278 30.9763 17.0308 32.2499 19.2368C33.5236 21.4428 34.1604 22.5458 34.2203 23.752C34.2285 23.9172 34.2285 24.0827 34.2203 24.2478C34.1604 25.454 33.5236 26.557 32.2499 28.7631C30.9763 30.9691 30.3395 32.0721 29.3248 32.727C29.1859 32.8167 29.0425 32.8995 28.8954 32.975C27.8209 33.5262 26.5472 33.5262 23.9999 33.5262Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_206_5328",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.329412 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_5328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_5328",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrademateActive);
export default __webpack_public_path__ + "static/media/trademate-active.4655ea4ec184e92ec83eaa7f32df9135.svg";
export { ForwardRef as ReactComponent };